import { EmailTemplate, TemplateVariable, RenderedEmail } from '../../models/EmailTemplate';

export const FETCH_EMAIL_TEMPLATES = 'FETCH_EMAIL_TEMPLATES';
export const FETCH_EMAIL_TEMPLATES_SUCCESS = 'FETCH_EMAIL_TEMPLATES_SUCCESS';
export const FETCH_EMAIL_TEMPLATES_FAILURE = 'FETCH_EMAIL_TEMPLATES_FAILURE';

export const UPDATE_EMAIL_TEMPLATE = 'UPDATE_EMAIL_TEMPLATE';
export const UPDATE_EMAIL_TEMPLATE_SUCCESS = 'UPDATE_EMAIL_TEMPLATE_SUCCESS';
export const UPDATE_EMAIL_TEMPLATE_FAILURE = 'UPDATE_EMAIL_TEMPLATE_FAILURE';

export const PREVIEW_EMAIL_TEMPLATE = 'PREVIEW_EMAIL_TEMPLATE';
export const PREVIEW_EMAIL_TEMPLATE_SUCCESS = 'PREVIEW_EMAIL_TEMPLATE_SUCCESS';
export const PREVIEW_EMAIL_TEMPLATE_FAILURE = 'PREVIEW_EMAIL_TEMPLATE_FAILURE';

export const FETCH_TEMPLATE_VARIABLES = 'FETCH_TEMPLATE_VARIABLES';
export const FETCH_TEMPLATE_VARIABLES_SUCCESS = 'FETCH_TEMPLATE_VARIABLES_SUCCESS';
export const FETCH_TEMPLATE_VARIABLES_FAILURE = 'FETCH_TEMPLATE_VARIABLES_FAILURE';

export const SELECT_TEMPLATE = 'SELECT_TEMPLATE';
export const CLEAR_PREVIEW = 'CLEAR_PREVIEW';
export const CLEAR_SAVE_STATUS = 'CLEAR_SAVE_STATUS';
export const SET_TEMPLATE_FIELD = 'SET_TEMPLATE_FIELD';

export interface EmailTemplatesState {
  templates: EmailTemplate[];
  selectedTemplate: EmailTemplate | null;
  variables: TemplateVariable[];
  previewResult: RenderedEmail | null;
  loading: boolean;
  error: string | null;
  correlationId: string | null;
  saving: boolean;
  saveSuccess: boolean;
  previewing: boolean;
}

export interface SetTemplateFieldPayload {
  field: keyof EmailTemplate;
  value: unknown;
}
